<template>
  <div>
    <background-wrapper :color="'#42337E'" content-padding="7px 0">
      <div class="banner">{{ $t(`products.${$route.name}.banner`) }}</div>
    </background-wrapper>
    <Hero :btn-text="$t(`products.${$route.name}.hero.button`)"/>
    <Features/>
    <ContentWithImage sectionName="cost-saving" text-size="sm" justify-center image-order="1" image-order-sm="0" :hide-btn="true" h2/>
    <ContentWithImage sectionName="scheduling-tool" text-size="sm" justify-center image-order="0" image-order-sm="0" :hide-btn="true" h2/>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_time-attendance'" ext="png">
      <text-container class="time-attendance" size="lg" align-center justify-center>
        <h2 class="h1" v-html="$t(`products.${$route.name}.time-attendance.title`)"/>
        <p class="h-sub" v-html="$t(`products.${$route.name}.time-attendance.text`)"/>
        <b-btn class="mt-2 mb-5" variant="primary" v-scroll-to="{ el: '#request-a-demo', offset: -70 }">
          {{$t(`request-demo`)}}
        </b-btn>
      </text-container>
    </background-wrapper>
    <ContentWithImage class="manage-time" sectionName="manage-time" text-size="sm" justify-center image-order="1" image-order-sm="0" :hide-btn="true" h2/>
    <div class="content-with-image pb-5">
      <b-row>
        <b-col class="image-column" md="12" cols="12">
          <div class="image-column__wrapper">
            <img src="@/assets/time-attendance/arrow.png">
          </div>
        </b-col>
      </b-row>
      <b-row align-v="center" id="request-a-demo" class="justify-items-sm-center mt-2 mb-5">
        <b-col class="image-column order-0" md="4" cols="12">
          <div class="image-column__wrapper let-me-know">
            <img src="@/assets/time-attendance/let-me-know.png">
          </div>
        </b-col>
        <b-col class="text-column" md="8" cols="12">
          <text-container>
            <h2 v-html="$t(`products.${$route.name}.let-me-know.title`)"/>
            <div id="hubspotForm" class="form" v-once />
          </text-container>
        </b-col>
      </b-row>
    </div>
    <Tools class="mt-5"/>
    <LetsGet/>
  </div>
</template>

<script>
import { Hero, Tools, LetsGet, Features, ContentWithImage } from '@/components/ui/products'

export default {
  name: 'TimeAttendance',
  components: { Hero, Tools, LetsGet, Features, ContentWithImage },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  },
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    document.body.appendChild(script)
    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '1890515',
          formId: '12b4d587-5802-40c6-bf0a-1f992380731f',
          target: '#hubspotForm'
        })
      }
    })
  }
}
</script>

<style lang="sass">
.manage-time
  img
    width: 450px!important
    +media-breakpoint-down(sm)
      width: 400px!important

.let-me-know
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  img
    width: 350px!important
    +media-breakpoint-down(sm)
      width: 450px!important
</style>

<style lang="sass" scoped>
#hubspotForm
  width: 100%

.time-attendance
  margin-top: -80px
  padding-top: 180px
  padding-bottom: 240px
  @media screen and (min-width: 2000px)
    padding-top: calc((100vw - 2000px)/6 + 180px)
    padding-bottom: calc((100vw - 2000px)/6 + 240px)
  +media-breakpoint-down(sm)
    padding-bottom: 380px

button
  min-width: 140px

.image-column
  &__wrapper
    +media-breakpoint-down(md)
      margin: auto!important

  img
    max-width: 100%
    width: 100%

  +media-breakpoint-down(sm)
    &.order-0
      margin-bottom: 50px
</style>



// WEBPACK FOOTER //
// src/components/products/TimeAttendance/TimeAttendance.vue